import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(
    () => Array.from({ length: 101 }, (_, i) => ({ id: i, text: `${i}%` })),
    []
  )
}
